import { Component, h, Prop, Element, State, Listen, Watch } from "@stencil/core";
import pfx from "../../../utils/style-class-prefix-helper";
import { detectMarkupChanges, detectSlotChanges } from "../../../utils/slot-helper";

@Component({
  tag: "eon-ui-accordion-pane",
  styleUrl: "accordion-pane.scss",
  shadow: true
})
export class AccordionPane {
  private innerDiv: HTMLElement;
  private overflowTimeout: any;

  @State() height: number;
  @State() overflowVisible: boolean = false;

  /**
   * Defines the name of the accordion
   */
  @Prop() paneTitle: string;

  /**
   * Determines whether the accordion is active or not
   */
  @Prop() isActive: boolean = false;

  @Element() hostElement: HTMLEonUiAccordionPaneElement;

  @Listen("resize", { target: "window" })
  onViewportChange() {
    /**
     * When pane is in "expand" mode then while toggling between viewports, the height of the pane remains static (which should not be the case per viewport),
     * So updating the height of pane on every viewport toggle to avoid any height mismatch issue.
     */
    if (this.innerDiv) {
      this.height = -1;
      this.height = this.innerDiv.offsetHeight;
    }
  }

  componentDidLoad() {
    detectMarkupChanges(() => {
      this.height = -1;
      this.height = this.innerDiv.offsetHeight;
    }, this.hostElement);

    detectSlotChanges(() => {
      this.height = -1;
      this.height = this.innerDiv.offsetHeight;
    }, this.hostElement);

    this.hostElement.querySelectorAll("EON-UI-IMAGE").forEach((elm) => {
      elm.addEventListener("imageSrcLoaded", () => {
        this.height = -1;
        this.height = this.innerDiv.offsetHeight;
      });
    });
  }

  componentDidRender() {
    /**
     * This produces a Stencil warning regarding a possible render-loop.
     * This is intended here - we need a rerender after the inner div has been rendered to get its real height.
     * After that, the state will update and the item will rerender again but this time Stencil detects that the value didn't change anymore.
     * Therefore, this will NOT result in a render loop and the warning can be ignored safely.
     */
    this.height = this.innerDiv.offsetHeight;
  }

  @Watch("isActive")
  toggleOverflow() {
    if (this.overflowTimeout) clearTimeout(this.overflowTimeout);
    if (this.isActive) {
      this.overflowTimeout = setTimeout(() => {
        this.overflowVisible = true;
      }, 300); // 300ms is aligned with the css transition time
    } else {
      this.overflowVisible = false;
    }
  }

  render() {
    return (
      <div
        class={pfx({
          "accordionitem-content": true,
          active: this.isActive,
          "overflow-visible": this.overflowVisible
        })}
        style={{
          height: `${this.isActive && this.height ? this.height : 0}px`
        }}
      >
        <div ref={(el) => (this.innerDiv = el as HTMLElement)} class={pfx("accordionitem-content-inner")}>
          <slot />
        </div>
      </div>
    );
  }
}
